export const PACKING_APPROVAL_REQUEST = "PACKING_APPROVAL_REQUEST";
export const PACKING_APPROVAL_SUCCESS = "PACKING_APPROVAL_SUCCESS";
export const PACKING_APPROVAL_FAIL = "PACKING_APPROVAL_FAIL";